export enum CrudItemsParentView {
   Items = 0,
   Actions = 1,
   Audits = 2,
   Tasks = 3,
   Task_Item = 4,
}
